import React, { useEffect, useState } from "react";

export const ScoreLoading = React.memo(() => {
  const [progress, setProgress] = useState(8);
  const [phaseIndex, setPhaseIndex] = useState(0);

    const phases = [
    {
        title: "Estamos simulando sua economia",
        subtitle: "Calculando sua estimativa com base nas informações informadas.",
    },
    {
        title: "Fazendo os cálculos…",
        subtitle: "Isso pode levar alguns instantes. Obrigado por aguardar.",
    },
    {
        title: "Quase lá…",
        subtitle: "Estamos finalizando para mostrar seu resultado.",
    },
    ];

  const tips = [
    "Não feche esta página para não perder seu progresso.",
    "Se demorar um pouco, é normal: estamos validando em ambiente seguro.",
    "Em seguida, você verá sua economia estimada.",
  ];

  useEffect(() => {
    // Progresso "percebido": sobe rápido no começo e desacelera perto do final.
    // Nunca chega em 100% sozinho (fica travado ~92%) até o score terminar.
    const interval = setInterval(() => {
      setProgress((p) => {
        if (p < 55) return p + 4;     // acelera no começo
        if (p < 78) return p + 2;     // meio
        if (p < 92) return p + 1;     // perto do fim
        return p;                      // trava em 92
      });
    }, 600);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Troca de fase (texto muda, sensação de avanço)
    const phaseTimer = setInterval(() => {
      setPhaseIndex((i) => (i + 1) % phases.length);
    }, 4500);

    return () => clearInterval(phaseTimer);
  }, []);

  const current = phases[phaseIndex];

  return (
    <div className="w-full flex flex-col items-center justify-center gap-6 py-10">
      {/* Ícone + headline */}
      <div className="flex flex-col items-center gap-3">
        <div className="w-14 h-14 rounded-full border-4 border-gray-200 border-t-claro-red animate-spin" />
        <h4
          className="text-center text-neutral-900 text-2xl font-bold"
          aria-live="polite"
        >
          {current.title}
        </h4>
        <p className="text-center text-neutral-600 text-base font-normal max-w-[360px]">
          {current.subtitle}
        </p>
      </div>

      {/* Barra de progresso */}
      <div className="w-full max-w-[420px]">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-neutral-600">Progresso</span>
          <span className="text-sm text-neutral-600">{progress}%</span>
        </div>

        <div className="w-full h-3 rounded-full bg-gray-100 overflow-hidden border border-gray-200">
          <div
            className="h-full rounded-full bg-claro-red transition-all duration-700 ease-out"
            style={{ width: `${progress}%` }}
            aria-label="Barra de progresso"
          />
        </div>

        <div className="mt-3 text-xs text-neutral-500 text-center">
          {tips[phaseIndex % tips.length]}
        </div>
      </div>

      {/* Mensagem extra */}
      <div className="w-full max-w-[420px] rounded-2xl border border-gray-200 p-4">
        <p className="text-sm text-neutral-700 text-center">
          Se essa validação levar mais tempo do que o esperado, pode ser por alta
          demanda no sistema. Assim que concluir, mostramos seu resultado automaticamente.
        </p>
      </div>
    </div>
  );
});